import React, { useEffect } from "react";
import "../css/HomePage.css"; // add this file next to HomePage.css (or merge if you prefer)

export default function FooterSection() {
  return (
    <footer className="mtg-footer">
      <div className="mtg-footer-inner">
        {/* Top: brand art, about, newsletter */}
        <div className="mtg-footer-top">
          <div className="mtg-footer-brand">
            <img
              src="https://mentortogether.org/wp-content/uploads/2024/11/Group-115.png"
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="mtg-footer-about">
            <p>
              Mentor Together empowers young people from underprivileged
              backgrounds by providing them with one-on-one mentoring
              relationships. These invaluable relationships foster personal
              growth, boost confidence, and equip mentees with the necessary
              skills to overcome challenges and achieve their aspirations.
            </p>
          </div>
        </div>

        {/* Bottom: quick links + socials */}
        <div className="mtg-footer-bottom">
          <nav className="mtg-footer-links" aria-label="Footer">
            <a href="/privacypolicy">Privacy Policy</a>
            <a href="/termsofservice">Terms of Service</a>
            <a href="/codeofconduct">Code of Conduct</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
